var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 166,
    viewBox: "0 0 171 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M39.3561 20.6886C30.3527 24.2921 20.7301 26.7745 12.8006 32.3528C4.87105 37.9311 -1.12562 47.8074 1.48781 57.1427C3.51552 64.3722 10.2764 70.0258 10.5832 77.537C10.8287 83.5253 6.86808 88.7549 4.76506 94.3667C0.51719 105.705 4.1905 118.911 11.7073 128.394C19.224 137.877 30.0598 144.186 41.1606 149.017C67.4679 160.43 96.3001 164.771 124.802 161.613C133.297 160.659 141.868 158.986 149.399 154.941C156.93 150.897 163.37 144.195 165.476 135.911C168.34 124.657 162.982 112.51 165.911 101.273C167.057 96.8658 169.434 92.841 170.446 88.4007C172.881 77.6987 166.948 66.7681 159.401 58.8023C151.854 50.8365 142.538 44.5999 135.637 36.0651C130.857 30.1549 127.354 23.2797 122.439 17.481C112.783 6.07063 97.189 -0.662367 82.2281 0.0516547C67.3647 0.757309 53.3715 15.074 39.3561 20.6886Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M34.2795 150.787L34.7063 152.722C31.9339 154.733 28.3833 155.213 25.0475 155.986C21.7116 156.758 18.175 158.1 16.4541 161.059C18.9337 164.272 23.5525 164.66 27.6107 164.766C60.3366 165.619 93.0784 165.736 125.836 165.117C136.228 164.919 146.679 164.643 156.879 162.643C157.61 162.501 158.427 162.289 158.793 161.639C159.417 160.523 158.235 159.277 157.155 158.624C153.575 156.479 149.472 155.367 145.299 155.408C143.731 155.428 141.673 155.26 141.313 153.735C141.19 153.177 141.358 152.619 141.338 152.061C141.294 150.667 140.097 149.551 138.783 149.133C137.47 148.714 136.047 148.854 134.672 148.979C108.758 151.473 82.4453 149.537 56.4449 148.209C52.3225 147.997 48.4456 150.257 44.3512 149.732C40.5077 149.247 37.7269 148.494 34.2795 150.787Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5781 10.4688H128.293C133.687 10.4688 138.061 14.8419 138.061 20.2363V140.644C138.061 146.038 133.687 150.411 128.293 150.411H43.5781C38.1837 150.411 33.8105 146.038 33.8105 140.644V20.2363C33.8105 14.8419 38.1837 10.4688 43.5781 10.4688Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5781 10.4688H128.293C133.687 10.4688 138.061 14.8419 138.061 20.2363V140.644C138.061 146.038 133.687 150.411 128.293 150.411H43.5781C38.1837 150.411 33.8105 146.038 33.8105 140.644V20.2363C33.8105 14.8419 38.1837 10.4688 43.5781 10.4688Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9243 105.718L32.5973 105.375C28.3084 105.352 24.8122 108.809 24.7877 113.098L24.7375 121.103C24.7096 125.396 28.1673 128.899 32.4603 128.927H32.4606L83.9818 129.247C87.3806 129.274 90.6381 130.612 93.0744 132.982L94.5164 134.377L94.5973 121.547L94.6168 118.479L94.6475 113.536C94.6706 109.247 91.2132 105.751 86.9243 105.727V105.718Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.118 26.5593V137.249C131.115 142.036 127.235 145.915 122.449 145.918H50.0067C45.2208 145.918 41.3408 142.038 41.3408 137.252V26.5593C41.3391 21.7734 45.218 17.8923 50.0039 17.8906H122.441C127.23 17.8876 131.115 21.7673 131.118 26.5565C131.118 26.5576 131.118 26.5585 131.118 26.5593Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M131.118 26.5593V137.249C131.115 142.036 127.235 145.915 122.449 145.918H50.0067C45.2208 145.918 41.3408 142.038 41.3408 137.252V26.5593C41.3391 21.7734 45.218 17.8923 50.0039 17.8906H122.441C127.23 17.8876 131.115 21.7673 131.118 26.5565C131.118 26.5576 131.118 26.5585 131.118 26.5593Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M86.373 31.0393C86.6268 29.9236 86.8806 28.808 86.7802 27.67C85.9094 28.5639 84.7201 29.0766 83.4722 29.0953C83.3241 29.0783 83.1744 29.1064 83.0427 29.1762C82.8703 29.3385 82.7881 29.575 82.8224 29.8093C82.8224 31.1788 82.8001 32.6235 82.1 33.7978C81.3999 34.972 80.195 35.6386 78.9371 36.0291C76.1479 36.916 73.1384 36.5284 70.2517 36.0821C69.5907 35.9789 68.8989 35.8617 68.3746 35.449C67.6634 34.8911 67.4207 33.8982 67.5155 33.0001C67.6104 32.102 67.9953 31.2624 68.3523 30.4257C68.9101 29.1009 69.3647 27.6868 69.2169 26.2615C69.0691 24.8362 68.1626 23.4054 66.7736 23.054C66.1806 22.8732 65.5363 23.0138 65.0722 23.4249C64.8538 23.6687 64.6851 23.9529 64.5758 24.2617C63.3926 27.1733 62.6264 30.2371 62.2998 33.3627C60.6877 33.2121 59.1509 34.0321 57.5583 34.2552C56.5347 34.4002 42.3853 34.4727 41.3561 34.403C41.3561 34.403 41.2111 36.0291 41.5932 36.5535C41.9753 37.0778 44.0504 37.0862 44.6613 37.3177C49.0095 38.9912 53.7929 38.8824 58.4285 39.3063C66.3441 40.0287 75.8579 42.5613 82.8475 37.4516C85.0202 35.8617 85.7928 33.5886 86.373 31.0393Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M97.2944 68.4985C97.4311 65.8404 96.639 63.2159 95.568 60.7781C94.4969 58.3404 93.1498 56.0366 92.0843 53.5961C91.8054 52.9797 91.6157 52.1374 92.1568 51.7385C92.3242 52.1569 92.974 52.0369 93.2976 51.7218C93.6211 51.4066 93.8554 50.9548 94.3045 50.8516C94.9457 51.8877 95.4954 52.9777 95.9473 54.1093L99.1158 61.3611C99.4532 62.1365 99.8075 62.9369 100.446 63.4892C101.436 64.3427 102.892 64.4236 104.161 64.3929C105.003 64.37 105.842 64.286 106.672 64.1418C107.6 63.9801 108.652 63.7123 109.199 62.9202C110.035 61.693 109.238 59.9498 109.756 58.5524C110.001 57.9723 110.396 57.4677 110.9 57.0909C111.544 56.5693 112.431 56.1621 113.184 56.5107C113.558 56.7202 113.872 57.0214 114.096 57.3865C116.049 60.1087 117.139 63.4446 119.502 65.8125C120.86 65.798 122.162 65.2723 123.15 64.3399C124.104 63.4334 124.823 62.3122 125.568 61.2328C126.851 59.3808 128.254 57.6069 129.657 55.8553L131.169 53.9559C131.21 53.8926 131.271 53.844 131.342 53.8164C131.514 53.7718 131.62 53.9921 131.671 54.1679C132.229 56.7311 130.538 59.219 128.725 61.11C127.331 62.5688 125.733 63.9773 124.751 65.7038C124.411 66.3007 124.619 67.0604 125.216 67.4004C125.217 67.401 125.218 67.4018 125.219 67.4024C125.375 67.4911 125.549 67.5452 125.727 67.5613C129.035 67.8403 132.421 67.1904 135.751 67.5948C136.758 67.7175 137.938 68.0941 138.102 69.1567C138.166 69.7026 137.957 70.2445 137.545 70.6071C136.836 71.2821 135.871 71.4159 134.934 71.5303C124.383 72.8273 113.736 73.2038 103.115 73.5524C102.697 73.5906 102.275 73.5555 101.869 73.4492C100.987 73.1703 100.474 72.2666 99.9748 71.4968C99.2304 70.3736 98.3275 69.3637 97.2944 68.4985Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.437 76.2553V83.3286C151.458 87.1026 148.416 90.1793 144.642 90.201H144.642H99.564C96.5807 90.191 93.7126 91.3515 91.5759 93.4336L90.3096 94.6581V76.2497C90.3018 73.2706 92.2176 70.6268 95.0511 69.7064C95.7191 69.4916 96.4164 69.3825 97.1179 69.3828H144.645C148.417 69.4043 151.458 72.4799 151.437 76.2522C151.437 76.2533 151.437 76.2544 151.437 76.2553Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7928 42.8229L78.9642 60.7515H77.7928L76.5488 59.555C74.4347 57.5273 71.216 56.8021 68.2902 56.8021H23.9762C20.2792 56.8021 17.2822 53.8051 17.2822 50.1081L17.6978 42.8229C17.6978 39.1259 20.6947 36.1289 24.3918 36.1289H71.11C73.3212 36.1239 75.391 37.2159 76.6353 39.0436C77.397 40.1562 77.8009 41.4746 77.7928 42.8229Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.962 42.8229V60.7515L77.7153 59.555C75.6055 57.527 72.793 56.3946 69.8666 56.3949H25.5387C21.8417 56.3949 18.8447 53.3979 18.8447 49.7009V42.8229C18.8447 39.1259 21.8417 36.1289 25.5387 36.1289H72.2681C74.479 36.125 76.5483 37.2164 77.7934 39.0436C78.5587 40.1551 78.9665 41.4735 78.962 42.8229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.437 75.6783V82.5536C151.437 86.2506 148.44 89.2475 144.743 89.2475H100.438C97.5107 89.2481 94.6973 90.3802 92.5862 92.4076L91.3311 93.5958V75.6783C91.3311 71.9922 94.311 68.9997 97.9971 68.9844H144.752C148.445 68.9891 151.437 71.9847 151.437 75.6783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.421 67.6239C102.142 67.0661 101.696 66.6421 101.423 66.101C100.837 64.9463 101.18 63.5127 101.872 62.4193C102.151 61.9647 102.513 61.5268 102.616 60.9997C102.736 60.3805 102.496 59.7055 102.756 59.1309C102.968 58.6679 103.448 58.4002 103.871 58.1045C104.516 57.6443 105.074 57.0419 105.802 56.7351C106.53 56.4283 107.539 56.5398 107.896 57.2483C108.568 56.9164 109.419 57.2176 109.921 57.7698C110.423 58.3221 110.646 59.0752 110.8 59.8059C110.931 60.6443 111.123 61.4721 111.374 62.2827C111.67 63.0776 112.189 63.8334 112.956 64.1932C114.445 64.8905 116.52 63.9868 117.697 65.1471C118.3 65.7468 118.515 66.8067 119.332 67.0354C119.753 67.1525 120.21 66.9991 120.629 67.1107C121.351 67.3059 121.65 68.1789 121.666 68.9264C121.691 70.408 121.098 71.8327 120.029 72.8591C119.51 73.3528 118.846 73.813 118.74 74.5326C118.729 74.8971 118.757 75.262 118.824 75.6204C118.938 77.0021 117.911 78.2146 116.529 78.3286C115.917 78.3791 115.308 78.2034 114.816 77.835C114.225 77.3943 113.726 76.6551 112.989 76.6886C112.667 76.7338 112.361 76.8562 112.097 77.0456C111.517 77.4414 110.876 77.7385 110.2 77.9242C109.51 78.1061 108.775 77.937 108.234 77.4724C107.815 77.0624 107.659 76.4655 107.456 75.9132C107.126 75.0207 106.527 74.1031 105.592 73.9246C105.191 73.8493 104.775 73.9246 104.374 73.8576C101.651 73.4197 103.25 69.2946 102.421 67.6239Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.221 58.2514C124.898 57.1718 125.41 55.9967 125.738 54.765C125.881 54.2485 126.117 53.7626 126.435 53.3314C126.514 53.2229 126.666 53.1986 126.774 53.2773C126.845 53.328 126.882 53.4125 126.873 53.4987L126.762 54.6144C127.32 53.9673 127.981 52.7819 128.915 51.7973C128.968 51.7446 129.054 51.7446 129.107 51.7973C129.143 51.8353 129.155 51.8902 129.138 51.9396L128.385 53.8278C128.372 53.8675 128.395 53.9098 128.434 53.9224C128.434 53.9224 128.435 53.9227 128.435 53.9227C128.463 53.931 128.494 53.9224 128.513 53.9004L129.629 52.397C130.234 51.9619 130.164 52.6006 130.109 52.7512L129.381 54.1458C129.36 54.1924 129.382 54.2468 129.428 54.2669C129.461 54.2811 129.499 54.2752 129.526 54.2518C129.843 53.9397 130.182 53.6488 130.538 53.3816C130.646 53.3093 130.791 53.3381 130.863 53.4455C130.913 53.5191 130.916 53.6142 130.873 53.6912L129.757 55.2503C129.623 55.4372 129.509 55.546 129.738 55.5292L130.541 55.2336C130.781 55.1387 130.667 55.6882 130.457 55.836C129.289 56.6728 128.815 57.3254 128.006 58.0199C127.197 58.7144 122.006 67.2743 119.638 70.3089C118.776 71.4106 117.128 72.1442 116.461 70.3703C115.962 69.0259 117.493 67.768 118.23 66.7946C120.342 64.0372 122.339 61.1895 124.221 58.2514Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0483 105.718L33.7213 105.375C29.4324 105.352 25.9362 108.809 25.9117 113.098L25.8615 121.103C25.8336 125.396 29.2913 128.899 33.5844 128.927H33.5846L85.0974 129.247C88.5013 129.27 91.7643 130.609 94.204 132.982L95.646 134.377L95.7268 121.547L95.7464 118.479L95.7771 113.536C95.8002 109.247 92.3428 105.751 88.0539 105.727L88.0483 105.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4852 14.1562H96.1739C96.6361 14.1562 97.0107 14.5308 97.0107 14.993C97.0107 15.4552 96.6361 15.8297 96.1739 15.8297H78.4852C78.023 15.8297 77.6484 15.4552 77.6484 14.993C77.6484 14.5308 78.023 14.1562 78.4852 14.1562Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3567 43.264C76.884 43.9 76.6246 43.7995 75.0488 44.0757C73.4729 44.3518 72.2401 44.151 70.7395 43.5904C69.7104 46.7309 68.617 50.1616 68.3381 53.4528C68.2463 54.4432 68.0871 55.4264 67.8611 56.3953H58.378C58.3502 56.1834 58.3251 55.9658 58.3027 55.7399C58.0526 52.7098 58.0871 49.6626 58.4059 46.6389C58.4316 46.454 58.4475 46.2677 58.4534 46.0811C58.4603 45.9288 58.4492 45.7762 58.4199 45.6264C58.3384 45.3046 58.2048 44.9983 58.0238 44.72C57.6473 44.0589 56.738 43.0465 56.2332 42.3129C56.1663 42.2125 56.1049 42.1177 56.0547 42.034C56.3587 40.6394 57.7003 39.9561 58.3251 38.687C58.7883 37.7164 59.4463 36.8515 60.2579 36.1461C60.5196 35.9258 60.7996 35.7278 61.0947 35.5548C62.1657 34.9328 63.4013 34.6846 64.6341 34.4977C64.8266 34.4671 65.0162 34.4392 65.2087 34.4141C65.9988 34.9911 66.9399 35.3264 67.9169 35.3791C68.2249 35.3724 68.5322 35.4053 68.8318 35.4767C69.0853 35.5735 69.3227 35.7091 69.5346 35.8784L69.9084 36.1573C70.5945 36.6454 71.2806 37.1391 71.9668 37.63C72.4426 37.9917 72.9494 38.3111 73.4813 38.5838C75.2022 39.3983 75.9134 39.323 77.8045 39.0831C78.0248 40.2741 78.2479 42.034 78.3567 43.264Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6193 34.4188C64.1256 34.8735 65.562 36.4438 66.0836 36.8677C66.6052 37.2917 67.3973 37.2889 68.0583 37.0936C68.499 36.9653 68.9676 36.7171 69.0875 36.2708C69.1274 35.9531 69.0978 35.6304 69.001 35.3253C68.8811 34.6699 69.001 33.9809 68.8225 33.3339C68.6228 32.6809 68.2167 32.1103 67.665 31.7078C67.149 31.3034 65.7573 30.2295 65.47 31.3034C65.1576 32.4469 65.774 33.3478 64.6193 34.4188Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5082 56.3976H58.6509C58.5427 56.1731 58.4225 55.9542 58.2911 55.7422C58.2633 55.6987 58.2306 55.6585 58.1935 55.6223C57.9366 55.3514 57.7581 55.0159 57.6775 54.6516C56.9247 52.0536 57.0472 49.28 58.0262 46.7584C58.1157 46.5048 58.2571 46.273 58.4418 46.0778C58.743 45.7571 59.0833 45.6009 59.404 45.0096C60.0372 43.8465 61.2449 41.8634 61.8417 40.6836C62.0788 42.9735 61.1891 45.096 61.2839 47.3943C61.3313 48.7331 61.3815 50.0942 61.8417 51.3549C62.2233 52.3955 62.8269 53.3405 63.6101 54.1245C63.9001 54.4564 64.3548 55.5525 64.5082 56.3976Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.793 39.0637C77.793 39.0637 78.2867 42.6645 78.2671 42.4581C78.2476 42.2517 85.3097 40.3272 87.3263 33.6416C87.4805 33.4193 87.6688 33.2224 87.8841 33.0587C90.3943 31.1844 90.7848 30.395 90.0345 30.8552C89.646 31.1219 89.1755 31.2415 88.7069 31.1927C88.9836 30.9601 89.2402 30.7043 89.4739 30.4285C89.7696 30.0687 90.4167 29.6977 90.5756 29.2626C90.5988 29.2141 90.6083 29.16 90.6035 29.1064C90.5731 29.0032 90.4736 28.9363 90.3665 28.9475C90.266 28.962 90.1704 29.0002 90.0875 29.059C89.7093 29.2955 89.3467 29.5563 89.0026 29.84C88.7878 30.0157 88.1965 30.2528 88.4001 29.84C88.7181 29.1845 89.4237 28.7494 89.6106 28.0466C89.6424 27.9673 89.6362 27.8781 89.5939 27.8039C89.5213 27.7147 89.3763 27.7425 89.2703 27.8039C88.8882 27.9768 87.7363 29.5583 87.4546 29.522C87.1729 29.4858 87.7586 27.8318 87.7809 27.5138C87.7809 27.4274 87.7809 27.3242 87.7056 27.2823C87.6219 27.2517 87.5277 27.2773 87.4713 27.3465C86.735 27.9545 86.6346 29.02 86.1604 29.8567C86.0974 29.9981 85.9825 30.1097 85.8397 30.1691C85.5356 30.2584 85.2818 29.9125 84.9722 29.8428C84.9173 29.8232 84.857 29.8232 84.8021 29.8428C84.632 29.9181 84.6571 30.183 84.7603 30.3392C86.1548 32.4646 82.6042 37.5771 77.793 39.0637Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0245 42.707C57.0245 42.707 55.5602 54.494 56.6815 56.3962H59.1164C58.6174 52.6088 58.7117 48.7667 59.3953 45.0081C59.3953 45.0081 59.1805 43.1533 57.0245 42.707Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M23.8956 42.0273H49.4721C50.3379 42.0273 51.0396 42.7291 51.0396 43.5948V43.5976C51.0396 44.4634 50.3379 45.1651 49.4721 45.1651H23.8956C23.0299 45.1651 22.3281 44.4634 22.3281 43.5976V43.5948C22.3281 42.7291 23.0299 42.0273 23.8956 42.0273Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M23.8956 48.4492H49.4721C50.3379 48.4492 51.0396 49.151 51.0396 50.0167V50.0195C51.0396 50.8853 50.3379 51.587 49.4721 51.587H23.8956C23.0299 51.587 22.3281 50.8853 22.3281 50.0195V50.0167C22.3281 49.151 23.0299 48.4492 23.8956 48.4492Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M145.622 76.8655H120.046C119.18 76.8655 118.477 76.164 118.476 75.298C118.476 74.4322 119.177 73.7305 120.043 73.7305H145.622C146.488 73.7305 147.19 74.4322 147.19 75.298C147.19 76.1637 146.488 76.8655 145.622 76.8655Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M145.622 83.2868H120.046C119.18 83.2868 118.477 82.5853 118.476 81.7193C118.479 80.8552 119.182 80.1571 120.046 80.1602H145.622C146.488 80.1602 147.19 80.8619 147.19 81.7277C147.184 82.5895 146.484 83.2854 145.622 83.2868Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M73.5981 113.657H48.0244C47.1584 113.657 46.4558 112.956 46.4541 112.09C46.4541 111.223 47.1572 110.52 48.0244 110.52H73.5981C74.4638 110.52 75.1656 111.221 75.1656 112.087C75.1673 112.953 74.4666 113.656 73.6009 113.657H73.5981Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M48.0236 117.684H73.6C74.4658 117.684 75.1675 118.385 75.1675 119.251V119.254C75.1675 120.12 74.4658 120.821 73.6 120.821H48.0236C47.1578 120.821 46.4561 120.12 46.4561 119.254V119.251C46.4561 118.385 47.1578 117.684 48.0236 117.684Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.386 71.4742C118.2 72.0011 117.884 72.4727 117.469 72.8465C116.69 73.5577 115.703 74.004 114.936 74.7264C113.235 76.3273 112.953 78.885 112.774 81.2139L112.153 89.2522H100.438C99.5983 89.2531 98.761 89.3465 97.9418 89.5312C98.0924 87.3743 98.2227 85.2172 98.3323 83.0603C98.5387 79.0077 98.547 74.5506 95.9643 71.4184C95.6963 71.1638 95.5116 70.8344 95.4344 70.4729C95.4009 70.0573 95.6826 69.6892 95.9476 69.3573C95.9643 69.3405 95.9755 69.3238 95.9922 69.3043L97.7159 67.1985C97.8922 66.9142 98.1758 66.7129 98.5024 66.6406C98.7864 66.6585 99.0527 66.7843 99.2471 66.9921C99.9109 67.5965 100.516 68.2622 101.054 68.9807C101.409 69.427 101.755 69.8788 102.123 70.3139C103.86 72.3667 106.513 73.8115 109.018 72.1659C110.738 71.0003 112.53 69.9449 114.384 69.0058C115.247 68.5869 116.133 68.2145 117.036 67.8902C116.983 68.3225 117.215 68.6739 117.502 69.0058C117.811 69.3202 118.082 69.6694 118.311 70.0462C118.525 70.4933 118.552 71.007 118.386 71.4742Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9589 69.2098C98.4975 68.2509 98.6755 67.1311 98.461 66.0525C98.2462 64.9851 97.9034 63.9475 97.4401 62.9621L94.5004 55.9893C94.236 55.4206 94.0313 54.8262 93.8896 54.2154C93.686 53.1722 93.8505 52.0956 94.0151 51.0469C93.8288 50.9936 93.6293 51.0134 93.4572 51.1027C93.5111 51.68 93.2087 52.232 92.693 52.4973C92.4342 51.4491 91.9592 50.4668 91.2984 49.6133C91.371 50.3923 91.4248 51.1733 91.4602 51.9562C90.8466 51.3258 90.231 50.6974 89.6138 50.0707C89.1369 50.9074 90.8522 51.7972 90.4505 52.6786L88.4256 51.2198C88.2778 52.2128 89.8843 52.6813 89.9708 53.6854L88.5177 53.0077C88.8245 53.758 89.5357 54.2461 90.0991 54.8318C92.1687 57.0101 92.1687 60.3822 93.4628 63.0904C94.2047 64.6496 94.9996 65.9242 95.3343 67.6284C95.5854 68.9086 96.6871 71.2543 97.9589 69.2098Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0593 84.8354C55.2716 84.8354 56.2544 83.8527 56.2544 82.6404C56.2544 81.4281 55.2716 80.4453 54.0593 80.4453C52.847 80.4453 51.8643 81.4281 51.8643 82.6404C51.8643 83.8527 52.847 84.8354 54.0593 84.8354Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8074 84.8354C62.0197 84.8354 63.0024 83.8527 63.0024 82.6404C63.0024 81.4281 62.0197 80.4453 60.8074 80.4453C59.5951 80.4453 58.6123 81.4281 58.6123 82.6404C58.6123 83.8527 59.5951 84.8354 60.8074 84.8354Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5535 84.8354C68.7658 84.8354 69.7485 83.8527 69.7485 82.6404C69.7485 81.4281 68.7658 80.4453 67.5535 80.4453C66.3412 80.4453 65.3584 81.4281 65.3584 82.6404C65.3584 83.8527 66.3412 84.8354 67.5535 84.8354Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.036 122.074C109.248 122.074 110.231 121.091 110.231 119.879C110.231 118.666 109.248 117.684 108.036 117.684C106.824 117.684 105.841 118.666 105.841 119.879C105.841 121.091 106.824 122.074 108.036 122.074Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78 122.074C115.992 122.074 116.975 121.091 116.975 119.879C116.975 118.666 115.992 117.684 114.78 117.684C113.568 117.684 112.585 118.666 112.585 119.879C112.585 121.091 113.568 122.074 114.78 122.074Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.524 122.074C122.736 122.074 123.719 121.091 123.719 119.879C123.719 118.666 122.736 117.684 121.524 117.684C120.312 117.684 119.329 118.666 119.329 119.879C119.329 121.091 120.312 122.074 121.524 122.074Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0935 47.355C100.306 47.355 101.289 46.3722 101.289 45.1599C101.289 43.9476 100.306 42.9648 99.0935 42.9648C97.8812 42.9648 96.8984 43.9476 96.8984 45.1599C96.8984 46.3722 97.8812 47.355 99.0935 47.355Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.841 47.355C107.053 47.355 108.036 46.3722 108.036 45.1599C108.036 43.9476 107.053 42.9648 105.841 42.9648C104.628 42.9648 103.646 43.9476 103.646 45.1599C103.646 46.3722 104.628 47.355 105.841 47.355Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.585 47.355C113.797 47.355 114.78 46.3722 114.78 45.1599C114.78 43.9476 113.797 42.9648 112.585 42.9648C111.372 42.9648 110.39 43.9476 110.39 45.1599C110.39 46.3722 111.372 47.355 112.585 47.355Z",
    fill: "#4444C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0597 31.1779C72.7585 32.2266 72.262 33.2586 71.4225 33.9671C69.8201 35.3047 67.4368 35.09 66.0994 33.4876C65.4512 32.7111 65.1414 31.7076 65.239 30.701C65.239 30.6145 65.239 30.5085 65.1776 30.4583C65.1126 30.436 65.0418 30.436 64.9768 30.4583C64.5668 30.5001 64.2628 30.0762 64.14 29.6857C64.0285 29.3903 64.0006 29.0699 64.0592 28.7597C64.1233 28.4471 64.3501 28.1927 64.6533 28.0931C64.9676 28.0055 65.295 28.1815 65.3952 28.492C65.4529 27.9115 65.644 27.3523 65.953 26.8575C66.2659 26.2129 66.6888 25.6278 67.2025 25.1282C68.3249 24.1822 69.8796 23.9373 71.2384 24.4923C72.4366 24.9874 73.3629 25.9756 73.7793 27.2034C73.9411 27.7612 73.704 28.2437 73.5953 28.7876C73.414 29.563 73.2885 30.3997 73.0597 31.1779Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.59 29.0198C65.5562 29.0652 65.5044 29.0937 65.4477 29.0979C65.339 29.0979 65.3111 28.9473 65.3027 28.8413C65.3052 28.5796 65.2051 28.3272 65.0238 28.1384C64.8355 27.9496 64.5301 27.9493 64.3413 28.1376C64.341 28.1378 64.3407 28.1381 64.3404 28.1384C64.1569 26.912 64.418 25.6605 65.0768 24.6101C65.1579 24.5094 65.2107 24.3892 65.2302 24.2615C65.2302 24.0969 65.1354 23.9352 65.166 23.7734C65.2017 23.6562 65.2729 23.5528 65.3696 23.4777C65.6625 23.1748 66.0173 22.9389 66.41 22.786C66.803 22.6326 67.2465 22.6826 67.5954 22.9199C68.4843 22.3958 69.4951 22.1138 70.5268 22.1027C71.1262 22.0896 71.7225 22.1908 72.2839 22.4011C73.2958 22.8215 74.1145 23.6041 74.5794 24.5962C75.0338 25.5872 75.1992 26.6867 75.0563 27.7674C73.1723 28.6195 70.9532 27.8057 70.0666 25.9378C69.9857 26.3751 70.0331 26.8267 70.2032 27.2375C69.514 26.8967 69.0262 26.2504 68.8868 25.4943C68.6776 25.2991 68.3596 25.5473 68.1867 25.7732C67.7404 26.3617 67.3276 27.0534 66.7921 27.5583C66.5508 27.7379 66.3294 27.9426 66.1311 28.1691C65.9163 28.4313 65.8271 28.7688 65.59 29.0198Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.639 72.2815C108.541 73.0597 107.816 73.7291 107.027 73.9188C106.827 73.9715 106.619 73.9885 106.413 73.969C105.297 73.8546 104.79 72.4768 104.812 71.3527C104.834 70.2287 105.091 69.0824 104.578 68.1257C104.578 68.095 104.547 68.0643 104.53 68.0337C104.251 67.54 103.763 67.1718 103.515 66.6558C103.287 66.0729 103.236 65.435 103.37 64.8233C103.702 62.4916 105.529 56.3304 109.049 58.637C109.961 59.2339 110.505 60.2659 110.817 61.309C111.922 64.9879 109.562 64.9238 108.639 72.2815Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.653 59.3879C108.125 59.6668 108.359 60.2246 108.465 60.7824C108.769 62.3304 108.275 63.9091 107.999 65.4626C107.723 67.0162 107.72 68.8096 108.811 69.9531L108.836 69.981C109.699 70.8596 111.111 70.8719 111.99 70.0089C112.202 69.8031 112.37 69.5563 112.484 69.2838C112.537 69.1638 112.598 69.0467 112.662 68.9323C113.086 68.182 113.678 67.5378 114.099 66.7847C114.442 66.1513 114.679 65.4665 114.802 64.757C114.957 64.034 114.962 63.2868 114.816 62.5619C114.537 61.3458 113.7 60.3306 112.824 59.4632C111.948 58.5957 111.059 57.865 109.951 57.4801C108.844 57.0952 107.522 57.1565 106.604 57.8789C106.326 58.1021 105.559 58.9946 105.957 59.3851C106.295 59.6863 107.159 59.0866 107.653 59.3879Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3118 42.7107L56.0371 42.0273L56.9603 43.2852L57.0217 42.7107H57.3118Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7393 43.5914C70.8218 42.927 71.4042 42.4398 72.0725 42.4758C73.322 42.4395 78.1695 41.8008 78.1695 41.8008L78.3564 43.2735C78.3564 43.2735 74.0695 45.0864 70.7393 43.5914Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M77.7923 39.0668V39.7194C77.7923 39.7194 73.5556 40.8602 69.0846 36.2581L68.8057 35.4688C69.0592 35.5655 69.2966 35.7011 69.5085 35.8704L69.8823 36.1493L71.9407 37.622C72.4165 37.9837 72.9233 38.3031 73.4552 38.5759C75.1761 39.3903 75.8873 39.315 77.7783 39.0751L77.7923 39.0668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M64.8521 35.4678C64.8521 35.4678 60.448 35.2531 58.3562 40.2735C57.9071 41.3446 56.8026 42.4379 56.8026 42.4379L56.2225 42.3152C56.1555 42.2148 56.0941 42.12 56.0439 42.0363C56.348 40.6417 57.6895 39.9584 58.3143 38.6893C58.7776 37.7187 59.4356 36.8538 60.2472 36.1484C60.5088 35.928 60.7888 35.73 61.0839 35.5571C62.155 34.9351 63.3906 34.6869 64.6234 34.5L64.8521 35.4678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.386 71.4739C118.2 72.0008 117.884 72.4724 117.469 72.8462C116.691 73.5574 115.703 74.0037 114.936 74.726C113.235 76.327 112.953 78.8847 112.775 81.2136L112.153 89.2519H103.303C103.303 89.2519 108.125 79.4564 109.439 76.8625C110.753 74.2686 114.769 72.5617 114.769 72.5617C117.898 70.1351 118.386 71.4739 118.386 71.4739Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.165 73.7779C107.126 73.8303 107.079 73.8764 107.026 73.9146C106.826 73.9673 106.618 73.9843 106.412 73.9648C105.296 73.8504 104.789 72.4726 104.811 71.3485C104.833 70.2245 105.249 69.1395 104.317 67.7227C104.805 68.0769 105.453 68.2972 106.869 68.3893C107.893 68.445 107.279 73.6301 107.165 73.7779Z",
    fill: "url(#paint20_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 89.1508,
    y1: 181.166,
    x2: 84.1248,
    y2: 110.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 80.5046,
    y1: 269.913,
    x2: 86.3423,
    y2: 66.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 58.3547,
    y1: 100.054,
    x2: 62.0671,
    y2: 147.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 86.9258,
    y1: 225.905,
    x2: 85.7264,
    y2: -22.0945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 64.0057,
    y1: 21.3944,
    x2: 64.7142,
    y2: 142.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 115.644,
    y1: 48.5028,
    x2: 106.928,
    y2: 207.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 122.397,
    y1: 56.9545,
    x2: 119.189,
    y2: 105.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 46.4445,
    y1: 25.1593,
    x2: 48.9269,
    y2: 70.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 116.363,
    y1: 61.5979,
    x2: 130.903,
    y2: 61.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 87.3296,
    y1: 9.36455,
    x2: 87.3296,
    y2: 35.7527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 65.2658,
    y1: 33.2317,
    x2: 68.9502,
    y2: 35.6025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 63.6071,
    y1: 48.4533,
    x2: 41.8546,
    y2: 52.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 77.793,
    y1: 34.8681,
    x2: 90.6048,
    y2: 34.8681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 56.2588,
    y1: 49.5517,
    x2: 59.4022,
    y2: 49.5517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 88.4161,
    y1: 59.8139,
    x2: 98.5496,
    y2: 59.8139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 68.5486,
    y1: 26.0629,
    x2: 69.8818,
    y2: 34.0147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F0DCCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 103.297,
    y1: 66.0529,
    x2: 111.106,
    y2: 66.0529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 57.194,
    y1: 42.394,
    x2: 56.3071,
    y2: 42.7287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5DB4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#50819B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#475C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#41455E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3F3D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 75.0162,
    y1: 41.4971,
    x2: 71.7669,
    y2: 54.7985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 108.201,
    y1: 78.8556,
    x2: 148.482,
    y2: 100.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 108.839,
    y1: 69.8929,
    x2: 81.215,
    y2: 77.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170.133,
    height: 165.509,
    fill: "white",
    transform: "translate(0.867188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.a5ec3189d29fb90e7529e91a31b6167a.svg";
export { ForwardRef as ReactComponent };